"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Input = require("./Input");

var _default = _Input.Input;
exports["default"] = _default;